// Identifying a company by its NAME — shared by the ai_analyst worker (whether a
// news headline names the company, issue #420) and the stock profile (whether
// an AI-supplied competitor ticker really is the company the AI named, issue
// #445). Moved here verbatim from workers/ai_analyst so the two cannot drift;
// the worker imports it cross-tree.

// Leading words too common to identify a company alone: the needle keeps taking
// words until it reaches one that isn't ("Bank of America", "First Solar").
const GENERIC_NAME_WORDS = new Set(['the', 'first', 'american', 'general', 'united', 'national',
    'international', 'global', 'advanced', 'new', 'great', 'bank', 'of', 'and', '&']);

const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// A regex matching `word` only as a whole word (`flags` e.g. 'i').
export const wholeWordPattern = (word, flags = '') => new RegExp(`\\b${escapeRegExp(word)}\\b`, flags);

export function companyNameNeedle(companyName) {
    const words = String(companyName || '').replace(/[,.]/g, ' ').split(/\s+/).filter(Boolean);
    const picked = [];
    for (const word of words) {
        picked.push(word);
        if (!GENERIC_NAME_WORDS.has(word.toLowerCase())) break;
    }
    if (picked[0]?.toLowerCase() === 'the') picked.shift();
    const needle = picked.join(' ');
    return needle.length >= 2 && needle !== 'N/A' ? needle : null;
}

// Does `storedName` (our company_profile name) name the company `claimedName`
// describes? The claimed name's needle must appear as a whole word. A
// parenthetical aside ("Block, Inc. (formerly Square)") is dropped first: it
// names a DIFFERENT company or brand, not this one.
//
// Deliberately strict — a rename the stored name does not mention ("Livongo
// (Teladoc Health)" -> TDOC) fails, and the caller shows the company without
// data rather than risk attaching another company's numbers (issue #445
// measured AI tickers naming the wrong company: "Direxion Bitcoin Bull" -> BITI,
// which is ProShares SHORT Bitcoin; "Fundrise" -> FUND, which is Sprott).
export function nameMentions(storedName, claimedName) {
    const needle = companyNameNeedle(String(claimedName || '').replace(/\([^)]*\)/g, ' '));
    if (!needle || !storedName) return false;
    return wholeWordPattern(needle, 'i').test(storedName);
}
